/**
 * Scroll Links.
 *
 * @format
 */

export const loadAnimatedLinks = (): void => {
  /**
   * Build Scroll Links.
   */
  const buildScrollLinks = (): void => {
    const scrollLinks: NodeListOf<Element> =
      document.querySelectorAll('.scroll-link');
    if (scrollLinks.length > 0) {
      Array.prototype.forEach.call(
        scrollLinks,
        (link: HTMLAnchorElement): void => {
          const anchor: string = link.href.substring(
            link.href.indexOf('#') + 1
          );
          const scrollSelector: Element | null =
            document.getElementById(anchor);
          if (scrollSelector) {
            link.addEventListener('click', (event): void => {
              event.preventDefault();
              scrollSelector.scrollIntoView({ behavior: 'smooth' });
            });
          }
        }
      );
    }
  };
  buildScrollLinks();

  /**
   * Create Button Ripple.
   *
   * @param event
   */
  const createRipple = (event) => {
    const button = event.currentTarget;

    console.log(
      `offsetLeft: ${button.offsetLeft}  offsetTop: ${button.offsetTop}`
    );
    console.log(event);
    console.log(event.currentTarget);

    const circle = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    circle.style.top = `${event.clientY - button.offsetTop - radius}px`;
    circle.classList.add('ripple');

    const ripple = button.getElementsByClassName('ripple')[0];
    if (ripple) {
      ripple.remove();
    }

    button.appendChild(circle);
  };

  /**
   * Setup Ripple Buttons.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setupRippleButtons = (): void => {
    const buttons: NodeListOf<HTMLElement> = document.querySelectorAll(
      '.btn-primary, .btn-primary-reversed, .btn-secondary, .btn-secondary-reversed'
    );
    Array.prototype.forEach.call(buttons, (button) => {
      button.addEventListener('mousedown', (e) => createRipple(e));
    });
  };
  // setupRippleButtons();
};

/**
 * Set Progress.
 */
export const setProgress = (percent: number, circleClass: string): void => {
  const circles: NodeListOf<SVGCircleElement> = document.querySelectorAll(
    `circle.${circleClass}`
  );
  if (circles.length > 0) {
    Array.prototype.forEach.call(circles, (circle: SVGCircleElement): void => {
      const radius: number = circle ? circle.r.baseVal.value : 0;
      const circumference: number = radius * 2 * Math.PI;
      const offset: number = circumference - (percent / 100) * circumference;

      circle.style.strokeDasharray = `${circumference} ${circumference}`;
      circle.style.strokeDashoffset = `${circumference}`;
      circle.style.strokeDashoffset = `${offset}`;
    });
  }
};
